import { render, staticRenderFns } from "./Webview.vue?vue&type=template&id=2d2ff9b5"
import script from "./Webview.vue?vue&type=script&lang=js"
export * from "./Webview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports